import { useState } from "react";
import { HiPencilAlt } from "react-icons/hi";
import { LuTrash2 } from "react-icons/lu";
import teamicon from "../../assets/teamicon.png";
import MatchStatusModal from "../../components/matchs/MatchStatusModal";

const MatchCard = ({
  match,
  onEdit,
  onDelete,
  isOwner,
  selectedSubcategory,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleEditClick = () => {
    setShowModal(true);
  };

  const handleSave = async (updatedMatch) => {
    try {
      await onEdit(updatedMatch);
      setShowModal(false);
    } catch (error) {}
  };

  const getStatusText = (status) => {
    switch (status) {
      case "scheduled":
        return "Por definirse";
      case "in_progress":
        return "En juego";
      case "completed":
        return "Finalizado";
      default:
        return status;
    }
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "completed":
        return "bg-green-600 text-white";
      case "in_progress":
        return "bg-yellow-500 text-black";
      case "scheduled":
        return "bg-gray-500 text-white";
      default:
        return "bg-gray-400 text-white";
    }
  };

  // Obtener la información de los equipos (nuevo)
  const team1Info = match.team1_info || {};
  const team2Info = match.team2_info || {};

  return (
    <>
      <div
        className="relative p-4 border border-gray-700 rounded-lg shadow-sm bg-gray-800 transition-all duration-200 hover:bg-gray-700 w-full"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Íconos de editar y eliminar */}
        {isHovered && isOwner && (
          <div className="absolute top-2 right-2 flex space-x-2">
            {onEdit && (
              <button
                onClick={handleEditClick}
                className="p-1 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition"
              >
                <HiPencilAlt size={16} />
              </button>
            )}
            {onDelete && (
              <button
                onClick={() => onDelete(match.id)}
                className="p-1 bg-red-500 text-white rounded-full hover:bg-red-600 transition"
              >
                <LuTrash2 size={16} />
              </button>
            )}
          </div>
        )}

        {/* Encabezado con estado (badge), fecha y hora */}
        <div className="flex justify-between items-start mb-3">
          {/* Estado como badge */}
          <span
            className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusStyle(
              match.status,
            )}`}
          >
            {getStatusText(match.status)}
          </span>

          {/* Fecha y hora */}
          <div className="flex flex-col text-right">
            <p className="text-sm text-gray-300">
              {new Date(match.match_date).toLocaleDateString("es-ES", {
                day: "2-digit",
                month: "2-digit",
              })}
            </p>
            <p className="text-sm text-gray-400">
              {new Date(match.match_date).toLocaleTimeString("es-ES", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })}
            </p>
          </div>
        </div>

        {/* Cuerpo con equipos y marcadores */}
        <div className="flex flex-col space-y-2">
          {/* Equipo 1 */}
          <div className="flex items-center justify-between">
            <div className="flex items-center min-w-0 flex-1">
              <img
                src={team1Info.picture_url || teamicon}
                alt={team1Info.team_name || "Equipo local"}
                className="w-8 h-8 rounded-full object-cover flex-shrink-0"
                onError={(e) => {
                  e.target.src = teamicon;
                }}
              />
              <span className="font-semibold ml-3 truncate">
                {team1Info.team_name || "Por definir"}
                {team1Info.category && team1Info.category !== 0 && (
                  <span className="ml-2 text-sm text-gray-400">
                    ({team1Info.category})
                  </span>
                )}
                {team1Info.group_name && (
                  <span className="ml-2 text-sm text-gray-400">
                    - {team1Info.group_name}
                  </span>
                )}
              </span>
            </div>
            <span className="text-lg font-bold ml-2">
              {match.score_team1 ?? "-"}
            </span>
          </div>

          {/* Equipo 2 */}
          <div className="flex items-center justify-between">
            <div className="flex items-center min-w-0 flex-1">
              <img
                src={team2Info.picture_url || teamicon}
                alt={team2Info.team_name || "Equipo visitante"}
                className="w-8 h-8 rounded-full object-cover flex-shrink-0"
                onError={(e) => {
                  e.target.src = teamicon;
                }}
              />
              <span className="font-semibold ml-3 truncate">
                {team2Info.team_name || "Por definir"}
                {team2Info.category && team2Info.category !== 0 && (
                  <span className="ml-2 text-sm text-gray-400">
                    ({team2Info.category})
                  </span>
                )}
                {team2Info.group_name && (
                  <span className="ml-2 text-sm text-gray-400">
                    - {team2Info.group_name}
                  </span>
                )}
              </span>
            </div>
            <span className="text-lg font-bold ml-2">
              {match.score_team2 ?? "-"}
            </span>
          </div>
        </div>
      </div>

      {showModal && (
        <MatchStatusModal
          match={match}
          onClose={() => setShowModal(false)}
          onSave={handleSave}
          selectedSubcategory={selectedSubcategory}
        />
      )}
    </>
  );
};

export default MatchCard;
